import { DOCUMENT,Inject, Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class CanonicalService {
  private _canonicalKeys = ['ppu', 'ppk'];

  constructor(@Inject(DOCUMENT) protected _document: Document) {}

  public addCanonicalIfNeeded(): void {
    const isCanonicalKeyInParams = this._canonicalKeys.some(key => this._document.URL.includes(key));

    if (isCanonicalKeyInParams) {
      this._createLinkForCanonicalURL();
    }
  }

  private _createLinkForCanonicalURL(): void {
    const link = this._document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', this._document.URL.split('?')[0]);
    this._document.head.appendChild(link);
  }
}
